import gql from 'graphql-tag';
import FieldsLanguage from "graphql/fields/FieldsLanguage";

export default gql(`
	query languages {
		languages {
			${FieldsLanguage}
		}
	}
`);

